<template>
<div class="dialog-popup-container" v-if="isVisible">
  <div @mouseup="outerClick" class="dialog-popup-wrapper fixed z-1000 w-full inset-0 flex items-center justify-center bg-black/50">
    <div class="dialog-popup-content w-[920px] min-h-[600px] bg-white flex-col flex">
      <div class="p-6 flex items-center justify-between h-auto pb-[20px]">
        <h1 class="text-md font-semibold uppercase text-[#23569F] text-base">{{ title }}</h1>
        <button class="bg-transparent border-0 text-black hover:text-gray-600 text-xl p-0" @click="closeDialog" ref="closeDialog">
          <el-icon><Close /></el-icon>
        </button>
      </div>
      <div class="pt-4 pb-2 mb-6 flex-none min-h-[80px] border-solid border-0 border-b-2 border-gray-500">
        <el-steps ref="progressComponent" v-if="progressScenario" :key="progressIndex + '/' + progressScenarioId" :active="progressIndex" align-center>
          <el-step
            v-for="(step, index) in progressScenario"
            v-bind:key="step.i18nLabel + index"
            v-bind:title="$t(step.i18nLabel)" />
        </el-steps>
      </div>
      <div class="px-6 text-left grow min-h-[375px]">
        <slot :activePageId="activePageId"></slot>
      </div>
      <div class="py-2 px-6 flex justify-between items-center common-form basis-10">
        <div class="w-half flex items-start">
          <el-button class="default width-auto" ref="navigatePrev" v-show="showPrevButton" @click="prevAction">{{ navigationPrevTitle || prevButtonTitle }}</el-button>
        </div>
        <div class="w-half flex items-end">
          <el-button class="self-end width-auto primary" ref="navigateNext" v-show="showNextButton"  @click="nextAction">{{ navigationNextTitle || nextButtonTitle }}</el-button>
          <el-button round type="danger" class="self-end width-auto failed-btn" ref="navigateFailed" v-show="showFailButton"  @click="failAction">{{ navigationFailTitle || failButtonTitle }}</el-button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script src="./dialog-popup.js"></script>
<style lang="scss" src="./dialog-popup.scss"></style>
